import React from 'react';
import Toast from './CustomToast';
import { useToastStore } from '../../zustandstore/toast';

/**
 * ToastContainer component
 * Renders all active toast notifications in a fixed position
 * Should be placed at the root level of your app
 */
const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useToastStore();

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div
      className="fixed top-4 right-4 z-50 flex flex-col gap-2"
      aria-live="polite"
      aria-label="Notifications"
    >
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} onClose={removeToast} />
      ))}
    </div>
  );
};

export default ToastContainer;
